import { useEffect, useState } from 'react';
import { getWorkflowDetails, getWorkflowEmailsAnalytics, resetWorkflowEmailsAnalytics } from '../actions';
import { getQueryWorkflowId } from 'modules/EmailBrowser/utils';
import EditionsList from 'modules/Campaigns/Emails/Components/EditionsList';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import SentEmailSearch from 'modules/Campaigns/Emails/Components/SentEmailSearch';
import styled from 'styled-components';
import useQuery from 'hooks/useQuery';
import { useHistory } from 'react-router-dom';
import { Col, Row } from 'antd';
import CustomChart from '../Shared/CustomChart';

const EmailsAnalytics: React.FC = () => {
  const query = useQuery();
  const history = useHistory();

  const queryWorkflowId = getQueryWorkflowId();
  const [isSearch, setIsSearch] = useState<boolean>(false);
  const [emails, setEmails] = useState<any[]>([])
  const allEmails = useSelector((state: RootState) => state.automation.emailAnalytics.data);
  const loading = useSelector((state: RootState) => state.automation.emailAnalytics.loading);
  const emailsCount = useSelector((state: RootState) => state.automation.emailAnalytics.emailsCount);
  const workflowId = useSelector((state: RootState) => state.automation.workflow.detail.id);

  useEffect(() => {
    if (!workflowId) {
      getWorkflowDetails(queryWorkflowId);
    }
    if (!allEmails.length) {
      getWorkflowEmailsAnalytics(queryWorkflowId, '');
    }
    const emailId = query.get('email_list_id');
    if (emailId) {
      const element = document.getElementById(emailId);
      if (element) {
        const headerHeight = document.getElementById('sticky-header')?.clientHeight || 0; // Replace 'header' with the ID or class of your fixed header element
        const elementTop = element.getBoundingClientRect().top;
        const offsetPosition = elementTop - headerHeight;

        window.scrollTo({
          top: window.pageYOffset + offsetPosition,
          behavior: 'smooth',
        });
      }
      query.delete('email_list_id');
      history.replace({
        search: query.toString(),
      });
    }
  }, []);

  useEffect(() => {
    if (allEmails.length) {
      setEmails(allEmails)
    }
  }, [allEmails])

  const handleSearch = (searchVal: string) => {
    if (searchVal.trim()) {
      setIsSearch(true);
      const tempEmails = allEmails.filter((email) => email.name.toLowerCase().includes(searchVal.toLowerCase()) || email.subject.toLowerCase().includes(searchVal.toLowerCase()) || email.sent_by.toLowerCase().includes(searchVal.toLowerCase()))
      setEmails(tempEmails)
    }
  };

  const resetSearch = () => {
    setIsSearch(false);
    setEmails(allEmails)
  };

  return (
    <Wrapper>
      <Row>
        <Col span={24} className="email-analytics-col">
          <div className="chart-container">
            <CustomChart
              title={'Engagement Trend'}
              boxRightOffset={'1.3%'}
              tooltip={'The graph shows the email engagement trend over time.'}
              emptyMessage="Your statistics will be shown here"
            />
          </div>
        </Col>
      </Row>
      <div className="d-flex flex-row justify-content-between align-items-center" style={{ marginTop: '26px' }}>
        <div className="d-flex align-items-center">
          <h3 className="heading-email">{`Emails (${emailsCount})`}</h3>
        </div>
        <div className="search-bar">
          <SentEmailSearch handleSearch={handleSearch} reset={resetSearch} placeholder="Search emails" />
        </div>
      </div>
      <EditionsList
        editionsLength={emailsCount}
        editionsLoading={loading}
        editions={emails}
        isWorkflowEmailsList={true}
        isSearch={isSearch}
        noSearchEmailText={`No sent emails found against your search`}
        tabState={'sent'}
      />
    </Wrapper>
  );
};

export default EmailsAnalytics;

const Wrapper = styled.div`
  .email-analytics-col {
    margin-top: 37px;
  }
  .heading-email {
    color: #67696a;
    font-family: 'Roboto';
    font-size: 22px;
    font-weight: 500;
  }
  .chart-container {
    background-color: #fff;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.08);
    height: 100%;
  }
  .search-bar {
    min-width: 260px;
    height: 34px;
  }
`;
